import { effect, inject } from '@angular/core';
import { Router } from '@angular/router';
import { AuthService } from '../services/auth.service';

export const authGuard = () => {
  const authService = inject(AuthService);
  const router = inject(Router);

  if (authService.isInitializing()) {
    return new Promise((resolve) => {
      const waitEffect = effect(() => {
        if (!authService.isInitializing()) {
          waitEffect.destroy(); // Beendet das Effect
          resolve(authService.isAuthenticated() ? true : router.createUrlTree(['/login']));
        }
      });
    });
  }

  return authService.isAuthenticated() ? true : router.createUrlTree(['/login']);
};
